const getAgeColor = (age: number): string => {
  // Normalize age between 10 and 90
  const normalizedAge = Math.min(Math.max(age, 10), 90);
  const percentage = (normalizedAge - 10) / (90 - 10);

  // Color stops from green to yellow to red
  if (percentage <= 0.5) {
    // Green to Yellow
    const r = Math.round(255 * (2 * percentage));
    const g = 255;
    return `rgb(${r}, ${g}, 0)`;
  } else {
    // Yellow to Red
    const g = Math.round(255 * (2 * (1 - percentage)));
    return `rgb(255, ${g}, 0)`;
  }
};

export const getAgeColorClass = (age: number): string => {
  const normalizedAge = Math.min(Math.max(age, 10), 90);
  const percentage = (normalizedAge - 10) / (90 - 10);

  if (percentage <= 0.33) return 'bg-green-500';
  if (percentage <= 0.66) return 'bg-yellow-500';
  return 'bg-red-500';
};